import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidEggCartonSums } from '../../../../mechanics/rid-egg-carton-sums/rid-egg-carton-sums';

@Component({
  selector: 'app-egg-carton-sums',
  imports: [RidEggCartonSums],
  templateUrl: './egg-carton-sums-page.html',
})
export class EggCartonSumsPage {
  protected readonly $router = inject(Router);
  protected readonly $activatedRoute = inject(ActivatedRoute);

  protected readonly typedAnswers = () => (this.$activatedRoute.snapshot.data['typedAnswers'] ?? true) as boolean;
}
